﻿import {SupplierSortByHookTypes} from "../../types/SupplierSortByHookTypes";
import {useEffect} from "react";
import _ from "underscore";
import {Supplier} from "../../types/Supplier";

const useSupplierSortByDailyRateLow = ({ searchSortBy, unsortedSuppliers, sortedSuppliersSetter }: SupplierSortByHookTypes) => {
  useEffect(() => {
    if (searchSortBy === 'daily-rate-low' && unsortedSuppliers.length) {
      sortedSuppliersSetter(_.sortBy(unsortedSuppliers, (supplier: Supplier) => supplier?.pricePerDay || Infinity));
    }
  }, [searchSortBy, sortedSuppliersSetter, unsortedSuppliers]);
}

export { useSupplierSortByDailyRateLow };
